/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Samuel's Portfolio",
  description:
    "A passionate developer who loves solving real world problems and learning new things.",
  og: {
    title: "Samuel Tan's Portfolio",
    type: "website",
    url: "http://samueltan.com/",
  },
};

//Home Page
const greeting = {
  title: "Samuel Tan Zhi Wei",
  logo_name: "Samuel Tan",
  nickname: "Sam",
  subTitle:
    "A passionate developer who loves solving real world problems and learning new things.",
  resumeLink:
    "https://drive.google.com/file/d/1vLWAgtO8x2wKKAEZsrvn9sVkZT88HqiK/view?usp=drive_link",
  portfolio_repository: "https://github.com/HypotheticalWhale/portfolio_app",
  githubProfile: "https://github.com/HypotheticalWhale",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/hypotheticalwhale",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/tanzhiweisamuel/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:samueltan.9803@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website frontend",
        "⚡ Developing mobile applications using React Native",
        "⚡ Creating application backend in Node, Express & SQL",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "cib:next-js",
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
    {
      title: "Data Science & Artificial Intelligence",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "Nanyang Technological University",
      subtitle: "B.Eng. in Computer Science",
      logo_path: "ntu_logo.png",
      alt_name: "NTU",
      duration: "2020 - 2023",
      descriptions: [
        "⚡ Basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Graduated second upper with honors, specializing in Machine Learning and Data Analytics",
      ],
    },
    {
      title: "Singapore Polytechnic",
      subtitle: "Diploma in Aerospace Electronics",
      logo_path: "sp_logo.png",
      alt_name: "SP",
      duration: "2016 - 2018",
      descriptions: [
        "⚡ Competencies in Avionics and Information and Communcation Technology for the aerospace sector.",
        "⚡ Electrical and Electronic systems through practical and hands-on lessons",
      ],
    },
  ],
};

const certifications = {
  certifications: [],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internships",
  description:
    "In my career, I've had internships in many different facets of computing and tech contributing to ML and DL Developer, Designer, and Software Development. I am pursing careers in Software and ML/DL.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: false,
      experiences: [
        {
          title: "Senior Software Engineer",
          company: "DSTA",
          company_url: "",
          logo_path: "dsta.png",
          duration: "Jan 2024 - Current",
          location: "Singapore",
          description:
            "∙ Provided technical leadership to the development team by prioritizing initiatives, delegating tasks effectively, and ensuring timely, high-quality delivery.\n∙ Served as Scrum Master for the SLDC, facilitating sprint ceremonies, removing impediments, and driving agile practices.\n∙ Architected and developed a micro-frontend web application using Single-SPA, TypeScript, and React (FE) with Spring Boot and Java (BE) seeing development through from ground 0 to deployment.\n∙ Owned full lifecycle delivery (ground zero to production), architecting the application, provisioning infrastructure, and implementing GitLab CI/CD pipelines to enable automated builds, testing and containerization (docker).",
          color: "#000000",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineering Intern",
          company: "SATS",
          company_url: "",
          logo_path: "sats_logo.svg.png",
          duration: "May 2023 - Aug 2023",
          location: "Singapore",
          description:
            "∙ Developed two minimum viable product (MVP) web applications in TypeScript using Next.js 12.\n∙ Participated in SLDC with cross-functional teams, including product managers, working in an agile methodology.\n∙ Ensured responsive designs and optimized user experience, integrating a backend architecture with Prisma ORM.",
          color: "#000000",
        },
        {
          title: "Data Science Intern",
          company: "PSA",
          company_url: "",
          logo_path: "psa_logo.png",
          duration: "May 2022 - Dec 2022",
          location: "Singapore",
          description:
            "∙ Utilized Pandas to analyze shipping routes and other shipping related information.\n∙ Streamlit to Dashboard shipping information - Data analytic skills to extract insights to support port planning.\n∙ Created a script funnel for generating vessel port of rotation as well as port to port coordinates, utilizing machine learning techniques to identify complex patterns.",
          color: "#ee3c26",
        },
        {
          title: "Product Intern",
          company: "Nium",
          company_url: "",
          logo_path: "nium.png",
          duration: "May 2021 - Aug 2021",
          location: "Singapore",
          description:
            "∙ MongoDB & NoSQL to support Product team in identifying Anti-Fraud hits that were inefficient.\n∙ Collaborated with Product Analytics teams to develop and implement MongoDB Charts to visualize in real time.",
          color: "#0071C5",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {},
  blogSection: {},
  addressSection: {},
  phoneSection: {},
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
